import { Block } from '~/common/components/Block/Block';
import { Form } from '~/common/components/Form/Form';
import { Controller, useForm } from 'react-hook-form';
import { useEffect } from 'react'
import { Markdown } from '~/common/components/Markdown/Markdown';
import { useUser } from '~/modules/user/models/user.hooks';
import { useGetCourse } from '~/modules/applications/models/application.hooks';
import { Link } from '~/common/components/Link/Link';
import { useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Button } from '~/common/components/Button/Button';
import { Input } from '~/common/components/Input/Input';
import { Textarea } from '~/common/components/Textarea/Textarea';
import { Checkbox } from '~/common/components/Checkbox/Checkbox';
import { AsyncSelect } from '~/common/components/Select/AsyncSelect';
import { applicationsRoutes } from '~/modules/applications/router/Router';
import { InputFile } from '~/common/components/InputFile/InputFile';
import { Select } from '~/common/components/Select/Select';
import { history } from '~/app/history/history';
import { useLoadCountriesRequest, useOnError, useSnackbar, useRef} from '~/modules/app/models/app.hooks';
import {
  citizenship,
  citizenshipOptions,
  visa,
  visaOptions,
  visaElligability,
  visaElligabilityOptions,
  yesOrNo,
  yesOrNoPairings,
  paymentPartner,
  paymentPartnerOptions,
  researchConsentOptions,
} from '~/modules/applications/models/application.model';
import { useDispatch } from 'react-redux';
import { noValueCodes, scrollToFirstError } from '~/modules/app/models/app.model';
import { setErrorsFunction, createFormData } from '~/common/libs/FormHelpers/FormHelpers';
// import {
//   createTAOnboarding
// } from '~/modules/applications/redux/applications.actions';
import {
  useCreateTAOnboardingRequest,
  useLoadApplicationsRequest
} from '~/modules/applications/models/application.hooks';
import { useWishToEnrollTARequest } from '~/modules/user/models/user.hooks';
dayjs.extend(utc);

const formNames = {
  legal_first_name: 'legal_first_name',
  legal_last_name: 'legal_last_name',
  citizenship: 'citizenship',
  country_residency: 'country_residency',
  country_services: 'country_services',
  country_citizenship: 'country_citizenship',
  services_us: 'services_us',
  partner_payment: 'partner_payment',
  citizenship_explained: 'citizenship_explained',
  certification_nonresident: 'certification_nonresident',
  visa_type: 'visa_type',
  visa_other: 'visa_other',
  visa_eligibility: 'visa_eligibility',
  other_information: 'other_information',
  privacy_notice: 'privacy_notice',
  incremental_payment: 'incremental_payment',
  research_consent: 'research_consent',
  electronic_signature: 'electronic_signature',
};

export const TAIntro = ({ application }) => {
  const user = useUser();
  const course = useGetCourse(application.course);
  const { register, handleSubmit, setValue, errors, setError, trigger, watch, getValues, control } = useForm();
  const startDate = dayjs(course.deadlines.start_date).utc().format('MMMM DD');
  const endDate = dayjs(course.deadlines.end_date).utc().format('MMMM DD');
  const acceptingEndDate = dayjs(course.deadlines.accepting_offer_end_date).utc().format('MMMM DD');
  const dispatch = useDispatch();
  const { setSnackbar } = useSnackbar();
  const wishToEnrollRequest = useWishToEnrollTARequest();

  const setErrors = setErrorsFunction(setError);
  // const onError = useOnError(setErrors);
  const onError = (errors, e) => {
      scrollToFirstError(errors);
      setSnackbar('Required fields missing');
    };

  const loadCountriesOptions = useLoadCountriesRequest();
  const loadApplications = useLoadApplicationsRequest();

  const citizen = watch(formNames.citizenship);
  const service = watch(formNames.services_us);
  const visaElligible = watch(formNames.visa_eligibility);
  const visaType = watch(formNames.visa_type);

  const setValueWithTrigger = (name, value) => {
    setValue(name, value);
    trigger(name);
  };

  const createTAOnboarding = useCreateTAOnboardingRequest();

  useEffect(() => {
    register({ name: formNames.citizenship });
    register({ name: formNames.services_us });
    register({ name: formNames.visa_eligibility });
    register({ name: formNames.visa_type });
    register({ name: formNames.research_consent });
  }, [register]);


  const onSubmit = data => {

    createTAOnboarding(application.id, data).then(() => {
        setSnackbar('Application is updated');
        loadApplications();
         wishToEnrollRequest(application.ta_application)
      })
      .catch(onError);

  };


  return (
    <Block title="TA Agreement & Onboarding">

    <Form onSubmit={handleSubmit(onSubmit, onError)}>
      <Form.Title>Intro</Form.Title>
        <Form.Row>
          <p>Congratulations! After reviewing your application, we would like to offer you a position as a TA
            in {application.course_name} from {startDate} - {endDate}.</p>
          </Form.Row>
            <Form.Row className="role-table">
            <center>
            <table   className="role-table" cellPadding="0" cellSpacing="0">
              <thead>
                  <tr>
                      <th scope="col">Possible Role</th>
                      <th scope="col" className="alignright">Your Role</th>
                  </tr>
              </thead>
              <tbody>
              <tr>
                <td>Lead Regular TA</td>
                <td className="alignright">  {(application.selected_as_lead_ta && application.ta_for=='regular_TA') ? <div>&#10004;</div> : ''} </td>
              </tr>
              <tr>
                <td>Lead Project TA</td>
                <td className="alignright">{(application.selected_as_lead_ta && application.ta_for=='project_TA') ? <div>&#10004;</div> : ''}</td>
              </tr>
              <tr>
                <td>Regular TA</td>
                <td className="alignright">{(!application.selected_as_lead_ta && application.ta_for=='regular_TA') ? <div>&#10004;</div> : ''}</td>
              </tr>
              <tr>
                <td>Project TA</td>
                <td className="alignright">{(!application.selected_as_lead_ta && application.ta_for=='project_TA') ? <div>&#10004;</div> : ''}</td>
              </tr>
              </tbody>
            </table>
              </center>
            </Form.Row>
       <Form.Row>
           <p>As shown above, you have been selected as a {application.selected_as_lead_ta ? 'lead': ''} {application.ta_for=='regular_TA' ? 'regular TA': ''} {application.ta_for=='project_TA' ? 'project TA':''}.
            Based on this, we compute that you will be paid ${application.amount_be_payed}.
          <br></br><br></br>
            We're so excited to have you with us. The next step is that we’d like you to decide whether you will commit to accepting our offer. To do so, please fill out the following form by {acceptingEndDate}.</p>
            The following link will take you first to your portal account and then redirect you to an Airtable form - please be patient as it can take a minute. If you aren't already signed into the portal, you will have to first sign-in for the redirect to work.


      {/*    <p>To complete this process, you will need your tax ID number, social security number, or other similar number for your home country or country of residence.</p>*/}

      {/*    <p>If you are in the United States on a visa and will be serving as a TA or other independent contractor from inside the US, you will also need to confirm that you are eligible to work as an independent contractor in the US under your visa status, and you'll need a scanned copy of your visa.</p>*/}

      {/*    <p>Please note: because the rules are different for every country around the globe, Neuromatch cannot provide tax advice on how to fill out tax forms (W-9, W8-BEN, or 8233 if applicable), or legal advice about whether you are eligible to be paid as an independent contractor. If you have questions about how to answer the questions in this form according to your specific home country and/or visa situation, or whether you are eligible to be paid as an independent contractor under these terms, you’ll need to ask one or more of the following resources:</p>*/}
      {/*    <ul>*/}
      {/*      <li>The international student/employee office at your home university or company, and/or</li>*/}
      {/*      <li>Your personal tax consultant</li>*/}
      {/*    </ul>*/}
      {/*    <p>Tax and visa information in this onboarding form is provided only as guidance and should not be taken as legal advice. Neuromatch is not authorized to determine your eligibility to be employed as an independent contractor under the terms of your citizenship, residency, current location, and/or visa status.</p>*/}

      {/*      <p>This form will dynamically change depending on how you answer various questions, which will tell you which forms you need to fill out and upload. If you need to look up information and come back to it, or ask someone for help, that's ok.</p>*/}

        </Form.Row>
      <Form.Row>
      <Link
              to="https://portal.neuromatchacademy.org/api/redirect/to/320359e1-1f6f-429b-a66d-ea04a34284b4"
              isCrossDomain
              newTab
            >
              Take me to the contractor agreement form
      </Link>
      <p>
        After you fill out the contractor agreement form, you should shortly (in 1-2 days) receive an invite to complete your tax information form. You are not considered enrolled until your Tax information form is complete and you have been notified by email that the information is approved.
      </p>
      </Form.Row>
      {/*<Form.Title>Neuromatch Independent Contractor Agreement</Form.Title>*/}
      {/*  <Form.Row>*/}
      {/*    <p>This independent contractor agreement (this “Agreement”) is made effective as of TODAY'S DATE (the “Effective Date”) by and between Neuromatch, a 501(c)(3) nonprofit corporation, (“Client”) and YOU (your first and last name as entered in form fields below; “you”).  In consideration of the terms, covenants, conditions and mutual promises set forth herein and for other good and valuable consideration, receipt of which is hereby acknowledged, Client and you mutually agree as follows:</p>*/}
      {/*    <ol>*/}
      {/*      <li><b>Services.</b>  Client hereby engages you, and you hereby accept the engagement, as an independent contractor to serve as a teaching assistant or other independent contractor to Neuromatch Academy’s 2021 summer program (the “Services”).  The manner and means by which you choose to complete the Services, including but not limited to the time and place you perform the services, are in your sole discretion and control.  You shall furnish, at your expense, the equipment, tools, supplies and materials used to perform the Services.</li>*/}
      {/*      <li><b>Fees and expenses.</b></li>*/}
      {/*        <ol>*/}
      {/*          <li>As full compensation for the Services and rights granted to Client herein, Client shall pay you YOUR COMPENSATION (auto-calculated from your confirmed position as Regular TA, Lead TA, Pre-pod participation, etc). This payment will be made after the completion of the Services. If for any reason you fail to complete the Services, you will be paid on a prorated basis for the portion of the Services completed.</li>*/}
      {/*          <li>You are solely responsible for travel and other costs and expenses incurred by you. You acknowledge that you will receive an IRS Form 1099-NEC and/or a Form W-8BEN from Client and that you shall be solely responsible for all federal, state and local taxes due.</li>*/}
      {/*        </ol>*/}
      {/*      <li><b>Relationship of the Parties; Insurance.</b>  This Agreement shall not be construed to create any association, partnership, joint venture, employee or agency relationship between you and Client.  You agree that you are an independent contractor of Client for all purposes, including for federal (including social security and unemployment), state and local tax purposes. Except to the extent required by applicable law, Client will not withhold any federal, state or local payroll taxes or any unemployment or similar taxes in respect of the Services. You have no authority to bind Client and you shall not act on behalf of Client without its prior written consent.  You will not be eligible to participate in any vacation, group medical or life insurance, disability, profit sharing, or retirement benefits or any other fringe benefits or benefit plans that are or may be offered by Client to its employees.  You shall not be entitled to any benefits under any insurance policies of Client and are solely responsible for maintaining appropriate worker’s compensation and general liability insurance throughout the term of this Agreement. Client reserves the right to obtain similar or identical services to those you are providing from any other person or entity.</li>*/}
      {/*      <li><b>Intellectual Property.</b></li>*/}
      {/*      <ol>*/}
      {/*        <li>You agree and acknowledge that Client does not anticipate the creation of any work product by you in the course of providing the Services, but to the extent you do develop, conceive, contribute to, reduce to practice or create any work product in the course of providing the Services, you hereby acknowledge and agree that, as between the Parties, Client is and shall be the sole and exclusive owner of all right, title and interest in and to all such work product and all copyrights and other intellectual property rights (other than the Retained Intellectual Property (see Section 4.2)) embodied in therein (“Work Product”).  In furtherance of the foregoing, you hereby acknowledge and agree that all Work Product shall be considered a “work made for hire” as defined in the United States Copyright Act of 1976, 17 U.S.C. § 101.  To the extent any portion of the Work Product does not qualify as, or otherwise fails to be, a “work made for hire,” you hereby assign to Client, all of your right, title and interest in and to the Work Product.  “Work product” here refers to any content developed or provided for the use of students, TAs, mentors, or conference attendees and used while providing Services (i.e., during the Academy course or projects, or during the hosting of a Conference). For example, if during the course of providing Services a project TA develops materials such as a rubric or base-code to help guide students with their projects, Client owns that content perpetually. If a TA brings previously-developed rubrics to use with the Academy, that TA grants Client perpetual use of those products under the terms described in Section 4.2. In contrast, if (a) the TA discusses or uses examples from their own work in the course of projects or tutorials or (b) in the course of the Services contributes ideas (whether or not patentable) to a student’s or group of students’ independent research program (whether or not used by such students or group of students), Client does not own the rights to these ideas but you grant Client (and students, if applicable) perpetual use of those ideas (under the terms of Section 4.2) with explicit attribution of credit to the TA.</li>*/}
      {/*        <li>To the extent any copyrights or other intellectual property rights that you created prior to signing this Agreement or independently from, and outside the scope of, the Services, is incorporated into, combined with or necessary to exploit any portion of the Work Product, you hereby grant Client a perpetual, irrevocable, sublicensable, transferrable, non-exclusive, fully paid-up, royalty-free, worldwide license to freely exploit such Retained Intellectual Property to the fullest extent of the rights therein, as part of, or in connection with, all or any portion of any Work Product. Whenever possible, Client will assign credit and attribution to you as the creator and owner of such Retained Intellectual Property.</li>*/}
      {/*        <li>You hereby irrevocably waive, to the extent permitted by applicable law, any and all claims you may now or hereafter have in any jurisdiction to any and all “moral rights” or equivalent rights with respect to the Work Product.</li>*/}
      {/*      </ol>*/}
      {/*      <li><b>Personal Data</b> Client will process personal information collected from you in compliance with the Neuromatch Privacy Notice (https://docs.neuromatch.io/p/kpUb79-ES8l_Gj/Privacy-Policy).</li>*/}
      {/*      <li><b>Publicity.</b> You shall not issue any press or publicity release or any advertisement, discuss the Services with any media representative, or publish or otherwise disclose any photograph or other information concerning this Agreement or the Services without the express prior consent of Client.</li>*/}
      {/*      <li><b>Confidentiality.</b>  You acknowledge that in connection with the Services, you will have access to information that is treated as confidential and proprietary by Client, including the existence and terms of this Agreement, information relating to Client personnel, the operations of Client and other sensitive or proprietary information of Client (which shall include all materials that are made available to you in order to perform the Services), and information regarding the projects you supervise in performing the Services (including any Work Product you may develop in connection therewith), in each case whether spoken, written or in other form or medium and whether or not identified as “confidential” (collectively, the “Confidential Information”). Any such information that you develop in connection with the Services shall also be deemed “Confidential Information” hereunder and be subject to this Section ‎7.  You agree to, at all times during the Term and thereafter, treat all Confidential Information as strictly confidential, not to disclose or permit to be disclosed Confidential Information to any third party without Client’s prior written consent, and not to use any Confidential Information for any purpose except as required in the performance of the Services.  The exception is that you may discuss the terms and existence of this Agreement with third parties for the purpose of determining your agreement with these policies. You shall notify Client immediately if you become aware of any loss or disclosure of any Confidential Information.</li>*/}
      {/*      <li><b>Representations and Warranties.</b>  You represent and warrant to Client that: (a) you have the right to enter into this Agreement and perform fully all of your obligations hereunder; (b) you have the required skill, experience and qualifications to perform the Services,  (c) your entry into this Agreement and your performance of the Services does not contravene or conflict with any provisions of any agreement or other instrument to which you are bound; (d) you shall perform the Services in compliance with all applicable federal, state and local laws and regulations and (e) to the extent you create any Work Product, such Work Product is your sole and original creation and that you exclusively own or have sufficient intellectual property and other proprietary rights to convey full rights in the Work Product as required hereunder, and such Work Product does not infringe, misappropriate or otherwise violate any right of any third party, including any copyright or other intellectual property right.</li>*/}
      {/*      <li><b>Term & Termination.</b>  Either party may terminate this Agreement effective immediately upon written notice.  Upon expiration or termination of this Agreement, or at any time upon Client’s written request, you, your successors or assigns shall (a) deliver to Client all Client Property; (b) deliver to Client or destroy (at Client’s option) all tangible documents and materials (and any copies) in your possession or control containing, reflecting, incorporating or based on Confidential Information; (c) permanently erase all Confidential Information from your computer systems; and (d) certify in writing to Client that you have complied with the foregoing requirements.</li>*/}
      {/*      <li><b>Miscellaneous.</b></li>*/}
      {/*      <ol>*/}
      {/*        <li>Survival. This Section ‎10 and Sections ‎2.2, 4, 5, 6, 7 and 8 shall survive the expiration or termination of this Agreement.  You shall not assign any rights, or delegate or subcontract any obligations, under this Agreement without Client’s prior written consent. </li>*/}
      {/*        <li>Notices. All notices and other communications hereunder shall be in writing and addressed to the parties hereto via electronic mail at the addresses set forth below (or such other address designated by the receiving party). Such notices shall be deemed delivered when sent.</li>*/}
      {/*        <li>Entire Agreement. This Agreement together with its schedules constitutes the entire agreement between you and Client with respect to the subject matter herein, and supersedes all other understandings, agreements and representations, written and oral, with respect to such subject matter.</li>*/}
      {/*        <li>Interpretation.  For purposes of this Agreement, (a) the words “include,” “includes,” and “including” are deemed to be followed by the words “without limitation”; (b) the word “or” is not exclusive; and (c) the words “herein,” “hereof,” “hereby,” “hereto” and “hereunder” refer to this Agreement as a whole. This Agreement is intended to be construed without regard to any presumption or rule requiring construction or interpretation against the party drafting an instrument or causing any instrument to be drafted.</li>*/}
      {/*        <li>Governing Law & Venue.  It is understood and agreed that the construction and interpretation of this Agreement shall at all times and in all respects be governed by the laws of the State of New York without regard to any choice or conflict of law provisions.  All actions arising out of or relating to this Agreement shall be heard and determined exclusively in a New York State or Federal court sitting in the borough of Manhattan, and the parties hereby irrevocably submit to the exclusive jurisdiction of such courts in any such action or proceeding and irrevocably agree to the laying of venue in such courts and waive the defense of an inconvenient forum to the maintenance of any such action.</li>*/}
      {/*        <li>Mediation & Arbitration.  Any controversy between the parties to this Agreement involving the construction or application of any of the terms, provisions, or conditions of this Agreement, shall on written request of either party served on the other, be submitted first to mediation and then if still unresolved to binding arbitration.  The mediation or binding arbitration shall comply with and be governed by the provisions of the American Arbitration Association for Commercial Disputes unless the parties stipulate otherwise.</li>*/}
      {/*        <li>Severability.  If any part of this Agreement is invalid or unenforceable, the remainder of this Agreement shall remain in force.  This Agreement may be executed in multiple counterparts, each of which shall be deemed an original and all of which together constitute one instrument.</li>*/}
      {/*        <li>Non-Waiver.  No assent or waiver, express or implied, of any breach of any term or condition hereof, nor any default hereunder, or failure of either party to enforce any term or condition hereof, shall be deemed or construed to be an assent or waiver of any subsequent breach or default of a similar nature, or waiver of any such term or condition hereof.</li>*/}
      {/*      </ol>*/}
      {/*    </ol>*/}
      {/*  </Form.Row>*/}
      {/*  <Form.Row>*/}
      {/*    <Input*/}
      {/*      name={formNames.legal_first_name}*/}
      {/*      innerRef={register({ required: "Required field"})}*/}
      {/*      label="Legal first name"*/}
      {/*      error={errors[formNames.legal_first_name]?.message}*/}
      {/*    />*/}
      {/*  </Form.Row>*/}
      {/*  <Form.Row>*/}
      {/*    <Input*/}
      {/*      name={formNames.legal_last_name}*/}
      {/*      innerRef={register({ required: "Required field"})}*/}
      {/*      label="Legal last name"*/}
      {/*      error={errors[formNames.legal_last_name]?.message}*/}
      {/*    />*/}
      {/*  </Form.Row>*/}
      {/*<Form.Title>US Citizenship or Residency & tax info</Form.Title>*/}
      {/*  <Form.Row>*/}
      {/*    <p>*/}
      {/*      This helps us and you decide which form(s) to fill out for you to get paid.*/}
      {/*      <br/><br/>*/}
      {/*      IMPORTANT: Almost every single person will fall into either the "US citizen", "US resident alien", or "Nonresident alien" category. If you do not know which of these to select, please ask someone at your home university or company.*/}
      {/*      <br/><br/>*/}
      {/*      Please do not just select "Other/No payment" if you don't know, as this will significantly delay your onboarding and payment if applicable.*/}
      {/*      <br/><br/>*/}
      {/*      ************/}
      {/*      <br/>*/}
      {/*      Definitions:*/}
      {/*      <br/><br/>*/}
      {/*      A United States citizen is someone who was born in the United States or has gained US citizenship through a naturalization or similar process.*/}
      {/*      <br/><br/>*/}
      {/*      A United States resident alien is a foreign-born United States resident who is not a U.S. citizen. A resident alien is also known as a permanent resident or a lawful permanent resident. Select this option if you are not a citizen but you live/work in the United States and have a Green Card or have passed the substantial presence test.*/}
      {/*      <br/><br/>*/}
      {/*      A nonresident alien of the United States is a person who is not a citizen of the United States and who has not passed a United States Green Card or substantial presence test. You should select this option if:*/}
      {/*      <br/><br/>*/}
      {/*      - you are in the US on a visa (as a student or postdoc),*/}
      {/*      <br/><br/>*/}
      {/*      OR*/}
      {/*      <br/><br/>*/}
      {/*      - you live/work in a country outside the US and have nothing to do with the US. */}
      {/*      <br/><br/>*/}
      {/*      For example, if you are a PhD student from Germany who is studying in the US on a visa, or you are a German citizen living in Germany, or you are a German citizen living and working in Japan, you should select this option.*/}
      {/*      <br/><br/>*/}
      {/*      ***** MOST people will fall into one of these three categories. If none of these categories applies to you, please select "Other/No payment" and explain why in the box that appears. ******/}
      {/*    </p>*/}
      {/*      <Controller*/}
      {/*          name={formNames.citizenship}*/}
      {/*          control={control}*/}
      {/*          rules={{ required: true }}*/}
      {/*          render={({ onChange, value, name, ref }) => (*/}
      {/*              <Select*/}
      {/*                  inputRef={ref}*/}
      {/*                  label="Which are you?"*/}
      {/*                  options={citizenshipOptions}*/}
      {/*                  value={citizenshipOptions.find(c => c.value === value)}*/}
      {/*                  onChange={val => onChange(val.value)}*/}
      {/*              />*/}
      {/*          )}*/}
      {/*        />*/}
      {/*        {errors[formNames.citizenship] && errors[formNames.citizenship]?.type === "required" ? (*/}
      {/*          <div className="error">*/}
      {/*              {"Must select one option"}*/}
      {/*          </div>*/}
      {/*        ) : null}*/}
      {/*  </Form.Row>*/}
      {/*  {citizen === citizenship.foreign_national && (*/}
      {/*    <Form.Row>*/}
      {/*      <Form.Title>Services in the US?</Form.Title>*/}
      {/*      <Controller*/}
      {/*          name={formNames.services_us}*/}
      {/*          control={control}*/}
      {/*          rules={{ required: true }}*/}
      {/*          render={({ onChange, value, name, ref }) => (*/}
      {/*              <Select*/}
      {/*                  inputRef={ref}*/}
      {/*                  label="​​You have indicated you are a nonresident alien of the United States (i.e., either you are in the US on a visa or you have nothing to do with the US). Will you be conducting any of your TA activities from a location INSIDE the United States?"*/}
      {/*                  options={yesOrNo}*/}
      {/*                  value={yesOrNo.find(c => c.value === value)}*/}
      {/*                  onChange={val => onChange(val.value)}*/}
      {/*              />*/}
      {/*          )}*/}
      {/*        />*/}
      {/*        {errors[formNames.services_us] && errors[formNames.services_us]?.type === "required" ? (*/}
      {/*          <div className="error">*/}
      {/*              {"Must select one option"}*/}
      {/*          </div>*/}
      {/*        ) : null}*/}
      {/*    </Form.Row>*/}
      {/*  )}*/}
      {/*  {((citizen === citizenship.foreign_national) && (service === yesOrNoPairings.no)) && (*/}
      {/*    <Form.Row>*/}
      {/*      <Form.Row>*/}
      {/*        <Form.Title>Country of Citizenship</Form.Title>*/}
      {/*        <Controller*/}
      {/*          name={formNames.country_citizenship}*/}
      {/*          control={control}*/}
      {/*          rules={{ required: true }}*/}
      {/*          render={({ onChange, value, name, ref }) => (*/}
      {/*              <AsyncSelect*/}
      {/*                  inputRef={ref}*/}
      {/*                  label="What country are you a citizen of?"*/}
      {/*                  loadOptions={loadCountriesOptions}*/}
      {/*                  value={[loadCountriesOptions].find(c => c.value === value)}*/}
      {/*                  onChange={val => onChange(val.value)}*/}
      {/*              />*/}
      {/*          )}*/}
      {/*        />*/}
      {/*        {errors[formNames.country_citizenship] && errors[formNames.country_citizenship]?.type === "required" ? (*/}
      {/*          <div className="error">*/}
      {/*              {"Must select one option"}*/}
      {/*          </div>*/}
      {/*        ) : null}*/}
      {/*      </Form.Row>*/}
      {/*      <Form.Row>*/}
      {/*        <Form.Title>Country of Residency</Form.Title>*/}
      {/*        <Controller*/}
      {/*          name={formNames.country_residency}*/}
      {/*          control={control}*/}
      {/*          rules={{ required: true }}*/}
      {/*          render={({ onChange, value, name, ref }) => (*/}
      {/*              <AsyncSelect*/}
      {/*                  inputRef={ref}*/}
      {/*                  label="What country are you a resident of?"*/}
      {/*                  loadOptions={loadCountriesOptions}*/}
      {/*                  value={[loadCountriesOptions].find(c => c.value === value)}*/}
      {/*                  onChange={val => onChange(val.value)}*/}
      {/*              />*/}
      {/*          )}*/}
      {/*        />*/}
      {/*        {errors[formNames.country_residency] && errors[formNames.country_residency]?.type === "required" ? (*/}
      {/*          <div className="error">*/}
      {/*              {"Must select one option"}*/}
      {/*          </div>*/}
      {/*        ) : null}*/}
      {/*      </Form.Row>*/}
      {/*      <Form.Row>*/}
      {/*        <Form.Title>Country of Services</Form.Title>*/}
      {/*        <Controller*/}
      {/*          name={formNames.country_services}*/}
      {/*          control={control}*/}
      {/*          rules={{ required: true }}*/}
      {/*          render={({ onChange, value, name, ref }) => (*/}
      {/*              <AsyncSelect*/}
      {/*                  inputRef={ref}*/}
      {/*                  label="What country will you be living and working in while conducting the Services?"*/}
      {/*                  loadOptions={loadCountriesOptions}*/}
      {/*                  value={[loadCountriesOptions].find(c => c.value === value)}*/}
      {/*                  onChange={val => onChange(val.value)}*/}
      {/*              />*/}
      {/*          )}*/}
      {/*        />*/}
      {/*        {errors[formNames.country_services] && errors[formNames.country_services]?.type === "required" ? (*/}
      {/*          <div className="error">*/}
      {/*              {"Must select one option"}*/}
      {/*          </div>*/}
      {/*        ) : null}*/}
      {/*      </Form.Row>*/}
      {/*      <Form.Row>*/}
      {/*        <Form.Title>Certification</Form.Title>*/}
      {/*        <Checkbox*/}
      {/*          name={formNames.certification_nonresident}*/}
      {/*          innerRef={register({ required: "Required field"})}*/}
      {/*          text="​​By checking this box you certify that: (1) you do not carry out any business or have a fixed base or establishment in the United States; and (2) no activities in connection with the Neuromatch program will be conducted in the United States."*/}
      {/*          error={errors[formNames.certification_nonresident]?.message}*/}
      {/*          />*/}
      {/*      </Form.Row>*/}
      {/*    </Form.Row>*/}
      {/*    )}*/}
      {/*    {((citizen === citizenship.foreign_national) && (service === yesOrNoPairings.yes)) && (*/}
      {/*    <Form.Row>*/}
      {/*      <Form.Row>*/}
      {/*        <Form.Title>Visa Type</Form.Title>*/}
      {/*        <Controller*/}
      {/*          name={formNames.visa_type}*/}
      {/*          control={control}*/}
      {/*          rules={{ required: true }}*/}
      {/*          render={({ onChange, value, name, ref }) => (*/}
      {/*              <Select*/}
      {/*                  inputRef={ref}*/}
      {/*                  label="What type of visa do you have?"*/}
      {/*                  options={visaOptions}*/}
      {/*                  value={visaOptions.find(c => c.value === value)}*/}
      {/*                  onChange={val => onChange(val.value)}*/}
      {/*              />*/}
      {/*          )}*/}
      {/*        />*/}
      {/*        {errors[formNames.visa_type] && errors[formNames.visa_type]?.type === "required" ? (*/}
      {/*          <div className="error">*/}
      {/*              {"Must select one option"}*/}
      {/*          </div>*/}
      {/*        ) : null}*/}
      {/*        {visaType === visa.other && (*/}
      {/*          <Form.Row>*/}
      {/*            <Form.Title>Other Visa Type</Form.Title>*/}
      {/*            <Input*/}
      {/*              name={formNames.visa_other}*/}
      {/*              label="​​You have indicated you hold a visa that is not of the F, J, M, or Q type. What is the type of your visa?"*/}
      {/*              innerRef={register({ required: "Required field"})}*/}
      {/*              error={errors[formNames.visa_other]?.message}*/}
      {/*            />*/}
      {/*          </Form.Row>*/}
      {/*        )}*/}

      {/*      </Form.Row>*/}
      {/*      <Form.Row>*/}
      {/*        <Form.Title>Eligibility as Paid Independent Contractor</Form.Title>*/}
      {/*        <Controller*/}
      {/*          name={formNames.visa_eligibility}*/}
      {/*          control={control}*/}
      {/*          rules={{ required: true }}*/}
      {/*          render={({ onChange, value, name, ref }) => (*/}
      {/*              <Select*/}
      {/*                  inputRef={ref}*/}
      {/*                  label="You have indicated you are a nonresident alien of the United States and some or all of your Services with Neuromatch will be conducted from within the United States.*/}
      {/*                  Are you eligible to be paid as an independent contractor in the United States according to the terms of your visa? "*/}
      {/*                  options={visaElligabilityOptions}*/}
      {/*                  value={visaElligabilityOptions.find(c => c.value === value)}*/}
      {/*                  onChange={val => onChange(val.value)}*/}
      {/*              />*/}
      {/*          )}*/}
      {/*        />*/}
      {/*        {errors[formNames.visa_eligibility] && errors[formNames.visa_eligibility]?.type === "required" ? (*/}
      {/*          <div className="error">*/}
      {/*              {"Must select one option"}*/}
      {/*          </div>*/}
      {/*        ) : null}*/}
      {/*      </Form.Row>*/}
      {/*    </Form.Row>*/}
      {/*    )}*/}
      {/*    {citizen === citizenship.no_payment && (*/}
      {/*    <Form.Row>*/}
      {/*      <Textarea*/}
      {/*        name={formNames.citizenship_explained}*/}
      {/*        label="​​Please explain why one of the main citizenship conditions does not apply to you.*/}
      {/*              If this is because you will be a volunteer for Neuromatch or you are not eligible to be paid through any of our mechanisms, please explain why that is the case here. "*/}
      {/*        innerRef={register({ required: "Required field"})}*/}
      {/*        error={errors[formNames.citizenship_explained]?.message}*/}
      {/*        />*/}
      {/*    </Form.Row>*/}
      {/*  )}*/}
      {/*  {(citizen === citizenship.no_payment || (service === yesOrNoPairings.yes && visaElligible === visaElligability.no)) && (*/}
      {/*    <Form.Row>*/}
      {/*      <Controller*/}
      {/*        name={formNames.partner_payment}*/}
      {/*        control={control}*/}
      {/*        rules={{ required: true }}*/}
      {/*        render={({ onChange, value, name, ref }) => (*/}
      {/*            <Select*/}
      {/*                inputRef={ref}*/}
      {/*                label="Your answers indicate you have a unique situation not covered by the most typical situations. This could mean that you are not eligible to be paid by Neuromatch at all, or we will need to work to determine your eligibility to be paid directly by one of our partner organizations. Please indicate which of the following options that apply to you, and we will be in contact to figure out your unique situation."*/}
      {/*                options={paymentPartnerOptions}*/}
      {/*                value={paymentPartnerOptions.find(c => c.value === value)}*/}
      {/*                onChange={val => onChange(val.value)}*/}
      {/*            />*/}
      {/*        )}*/}
      {/*      />*/}
      {/*      {errors[formNames.partner_payment] && errors[formNames.partner_payment]?.type === "required" ? (*/}
      {/*          <div className="error">*/}
      {/*              {"Must select one option"}*/}
      {/*          </div>*/}
      {/*        ) : null}*/}
      {/*    </Form.Row>*/}
      {/*  )}*/}

      {/*<Form.Title>File Uploads</Form.Title>*/}
      {/*<Form.Row>*/}
      {/*Based on your answers, we will need the following forms from you:*/}
      {/*</Form.Row>*/}
      {/*<ol>*/}
      {/*{(citizen === citizenship.us_citizen || citizen === citizenship.us_resident_alien) && (*/}
      {/*     <li><b>W-9 Form</b><Form.Label>Because you are either a US citizen or a US resident alien, you should submit form W-9, found at <a href ="https://www.irs.gov/pub/irs-pdf/fw9.pdf">https://www.irs.gov/pub/irs-pdf/fw9.pdf</a>. Any questions about how to fill out this form should be directed to your local tax or employment specialist at your home university or company. Neuromatch cannot provide legal or tax advice</Form.Label></li>*/}
      {/*)}*/}
      {/*{(citizen === citizenship.foreign_national) && (*/}
      {/*    <li><b>W8-BEN Form</b><Form.Label>Because you are a nonresident alien of the United States and EITHER no activity connected with your TA position will be conducted in the United States (i.e., you have nothing to do with the US) OR you are in the United States on a visa, you should submit form W8-BEN,found at <a href="https://www.irs.gov/pub/irs-pdf/fw8ben.pdf">https://www.irs.gov/pub/irs-pdf/fw8ben.pdf</a>. Any questions about how to fill out this form should be directed to your local tax or employment specialist at your home university or company. Neuromatch cannot provide legal or tax advice.</Form.Label></li>*/}
      {/*  )}*/}
      {/*{((citizen === citizenship.foreign_national) && (service === yesOrNoPairings.yes) && (visaElligible === visaElligability.yes_have_opt_or_cpt || visaElligible === visaElligability.yes_intent_opt_or_cpt)) && (*/}
      {/*     <li><b>Visa</b> <Form.Label>You have indicated you are a nonresident alien of the United States and some or all of your Services with Neuromatch will be conducted from within the United States, and that you are eligible to be paid as an independent contractor according to the terms of your visa. We need to see your visa to confirm how we can pay you. Please upload a scanned copy of your visa.</Form.Label></li>*/}
      {/*)}*/}
      {/*{((citizen === citizenship.foreign_national) && (service === yesOrNoPairings.yes) && (visaElligible === visaElligability.yes_have_opt_or_cpt || visaElligible === visaElligability.yes_intent_opt_or_cpt)) && (*/}
      {/*     <li><b>Form 8233</b> <Form.Label>*/}
      {/*        Generally, a payment to a nonresident alien independent contractor working in the U.S. is considered payment for “independent personal services” that is treated as U.S. source income. Such payments are subject to withholding at a flat rate of 30%, unless reduced by an applicable income tax treaty. Some other countries have similar rules.*/}
      {/*        <br/><br/>*/}
      {/*        If you believe you are exempt from this withholding under an applicable income tax treaty, please fill out IRS Form 8233 and upload it.*/}
      {/*        Form 8233 can be found <a href = "https://www.irs.gov/pub/irs-pdf/f8233.pdf">here</a>.*/}
      {/*        The IRS lookup table for tax treaties can be found <a href = "https://www.irs.gov/businesses/international-businesses/united-states-income-tax-treaties-a-to-z "> here</a>*/}
      {/*     </Form.Label></li>*/}
      {/* )}*/}
      {/*  {((citizen === citizenship.foreign_national) && (service === yesOrNoPairings.yes) && visaElligible === visaElligability.yes_intent_opt_or_cpt) && (*/}
      {/*      <li><b>OPT/CPT request letter</b><Form.Label>*/}
      {/*      You have indicated you are a nonresident alien of the United States and some or all of your Services with Neuromatch will be conducted from within the United States. The terms of your visa may require you to apply for OPT or CPT with your home company or university. If you need an independent contractor offer letter for an OPT/CPT application or for some other purpose, download this file and fill out the highlighted fields as relevant, then upload it. We'll sign it and email it back to you.*/}
      {/*      <br/>Link to template letter: <a href = "https://docs.google.com/document/d/1B2jKwVANPcL50rNewlU4QNuZb167qQ4Zjr-c6DPFuCU/edit?usp=sharing"> here</a>*/}
      {/*      </Form.Label></li>*/}
      {/*  )}*/}
      {/*</ol>*/}
      {/*<Form.Row>*/}
      {/*Please prepare these forms and then upload them using this*/}
      {/*{' '}<Link*/}
      {/*      to="https://portal.neuromatchacademy.org/api/redirect/to/bc5d25ec-1ba6-44cb-b0bd-a106e2dd6470"*/}
      {/*      isCrossDomain*/}
      {/*      newTab*/}
      {/*    >*/}
      {/*      airtable form*/}
      {/*    </Link>{' '}*/}
      {/*  This link will redirect through the portal, which may take a minute and require you to sign in.*/}
      {/*</Form.Row>*/}
      {/*<Form.Title>Other Info</Form.Title>*/}
      {/*  <Form.Row>*/}
      {/*    <p>*/}
      {/*    Is there anything else specific or unique about your residency, tax, visa, citizenship, location, payment routing, currency, etc. that you'd like us to know?*/}
      {/*    <br/><br/>*/}
      {/*    Please do not enter sensitive information such as social security number, tax ID number, or payment details (like bank account #) here. All payment details will be sent through our secure payment portal, bill.com, or through other secure means. After you submit this form you will be redirected to a set of instructions for how to get paid, including how and where to securely transmit bank account information.*/}
      {/*    <br/><br/>*/}
      {/*    Please note: if you are in Canada on a visa (not a Canadian citizen) please tell us that here. This impacts which bank account we will pay you from. Thanks!*/}
      {/*    </p>*/}
      {/*    <Textarea*/}
      {/*      name={formNames.other_information}*/}
      {/*      innerRef={register}*/}
      {/*      error={errors[formNames.other_information]?.message}*/}
      {/*    />*/}
      {/*  </Form.Row>*/}
      {/*  <Form.Row>*/}
      {/*    <Form.Title>Incremental Payment</Form.Title>*/}
      {/*    <Checkbox*/}
      {/*      name={formNames.incremental_payment}*/}
      {/*      innerRef={register}*/}
      {/*      text= {*/}
      {/*          <p>*/}
      {/*          Neuromatch's payment policy is to pay you within 30 days of the end of each course. This assumes all your tax paperwork is correct and you upload an invoice immediately after the end of the course. Under some exceptional circumstances, some people need to be paid incrementally or earlier than the standard 30-day payment policy.*/}
      {/*            <br></br><br></br>*/}
      {/*            If you need a personal exception to our standard payment timeline, please tick this box and we will reach out to discuss alternative payment timelines. Please note that we cannot guarantee payment times due to every bank/system around the world being different, but we always try our best.*/}
      {/*          </p>*/}
      {/*            }*/}
      {/*      error={errors[formNames.incremental_payment]?.message}*/}
      {/*      />*/}
      {/*  </Form.Row>*/}
      {/*  <Form.Row>*/}
      {/*    <Form.Title>Privacy Notice</Form.Title>*/}
      {/*    <Checkbox*/}
      {/*      name={formNames.privacy_notice} */}
      {/*      innerRef={register({ required: "Required field"})}*/}
      {/*      text= {*/}
      {/*          <p>*/}
      {/*          Check this box to indicate you have read and agree to the Neuromatch privacy notice, found <a href="https://docs.neuromatch.io/p/kpUb79-ES8l_Gj/Privacy-Policy">here</a>*/}
      {/*          </p>*/}
      {/*            }*/}
      {/*      error={errors[formNames.privacy_notice]?.message} */}
      {/*      />*/}
      {/*  </Form.Row> */}
      {/*  <Form.Row>*/}
      {/*    <Form.Title>Research Consent</Form.Title>*/}
      {/*    <p>*/}
      {/*    Neuromatch Academy wants to learn how we can improve our program even more!  We would love your help with this!*/}
      {/*    <br/><br/>*/}
      {/*    One of the things we can do is use automatic Zoom transcripts to understand how you interact with your podmates and how this improves pod-based learning. (This is not audio or video recordings, just transcripts.) This data would also be de-identified (anonymized).*/}
      {/*    <br/><br/>*/}
      {/*    Please read this description of OPTIONAL data use/sharing with research teams *outside NMA* to help us improve NMA for future students and TAs.*/}
      {/*    <br/> <a href="https://docs.google.com/document/d/1DLwB1lubWQc6HtFOeYDDeDgPNyhnPG_UwDz32WES8zg/edit?usp=sharing">https://docs.google.com/document/d/1DLwB1lubWQc6HtFOeYDDeDgPNyhnPG_UwDz32WES8zg/edit?usp=sharing</a>*/}
      {/*    <br/><br/>*/}
      {/*    Any data we want to share with these outside research teams will be “de-identified”, meaning that your name and other identifying information (like your email address) will be removed so that your answers and data remain anonymous.*/}
      {/*    </p>*/}
      {/*    <Controller*/}
      {/*      name={formNames.research_consent}*/}
      {/*      control={control}*/}
      {/*      rules={{ required: true }}*/}
      {/*      render={({ onChange, value, name, ref }) => (*/}
      {/*        <Select*/}
      {/*            inputRef={ref}*/}
      {/*            label="Do you agree to let us share your **anonymized** data with a research team *outside* Neuromatch? This is optional and does not affect your participation in NMA."*/}
      {/*            options={researchConsentOptions}*/}
      {/*            value={researchConsentOptions.find(c => c.value === value)}*/}
      {/*            onChange={val => onChange(val.value)}*/}
      {/*        />*/}
      {/*      )}*/}
      {/*    />*/}
      {/*    {errors[formNames.research_consent] && errors[formNames.research_consent]?.type === "required" ? (*/}
      {/*          <div className="error">*/}
      {/*              {"Must select one option"}*/}
      {/*          </div>*/}
      {/*        ) : null}*/}
      {/*  </Form.Row>*/}

      {/*<Form.Title>Finalization</Form.Title>*/}
      {/*  <Form.Row>*/}
      {/*    <Input*/}
      {/*      name={formNames.electronic_signature}*/}
      {/*      label="​​By typing your first and last name here you indicate: (1) you agree with the terms of the independent contractor agreement as outlined above; and (2) all of the information you have submitted here is true and correct to the best of your knowledge."*/}
      {/*      innerRef={register({ required: "Required field"})}*/}
      {/*      error={errors[formNames.electronic_signature]?.message}*/}
      {/*      />*/}
      {/*  </Form.Row> */}

      {/*  <Form.Row>*/}
      {/*    <Button type="submit" onClick={() => trigger()}>*/}
      {/*     Submit*/}
      {/*    </Button>*/}
      {/*  </Form.Row>*/}
    </Form>
    </Block>
  );
};
